function normalizedKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');
}

function humanize(value) {
  const acronyms = new Set(['ai', 'api', 'apis', 'ats', 'ceo', 'cfo', 'coo', 'cto', 'hr', 'it', 'llm', 'ml', 'qa', 'seo', 'ui', 'ux']);
  return String(value || '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .map((word) => (acronyms.has(word.toLowerCase())
      ? word.toUpperCase()
      : `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`))
    .join(' ');
}

const WORK_MODES = {
  remote: ['Remote', 'عن بُعد'],
  'remote only': ['Remote', 'عن بُعد'],
  hybrid: ['Hybrid', 'هجين'],
  'on site': ['On-site', 'في مقر العمل'],
  onsite: ['On-site', 'في مقر العمل'],
  'open to relocation': ['Open to relocation', 'متاح للانتقال'],
};

const EMPLOYMENT_TYPES = {
  'full time': ['Full time', 'دوام كامل'],
  'part time': ['Part time', 'دوام جزئي'],
  contract: ['Contract', 'عقد'],
  temporary: ['Temporary', 'مؤقت'],
  internship: ['Internship', 'تدريب'],
  'internship co op': ['Internship / co-op', 'تدريب / تعليم تعاوني'],
  freelance: ['Freelance', 'عمل حر'],
  permanent: ['Permanent', 'دائم'],
};

const JOB_CATEGORIES_AR = {
  accounting: 'المحاسبة',
  'administration and office': 'الإدارة والأعمال المكتبية',
  'advertising and marketing': 'الإعلان والتسويق',
  'agriculture and food': 'الزراعة والغذاء',
  'architecture and construction': 'الهندسة المعمارية والإنشاءات',
  arts: 'الفنون',
  'business and finance': 'الأعمال والتمويل',
  communication: 'الاتصالات',
  'community service and volunteering': 'خدمة المجتمع والعمل التطوعي',
  'customer service': 'خدمة العملاء',
  'data analysis': 'تحليل البيانات',
  'data analytics': 'تحليل البيانات',
  economics: 'الاقتصاد',
  'education and teaching': 'التعليم والتدريس',
  engineering: 'الهندسة',
  fashion: 'الأزياء',
  'government and public sector': 'الحكومة والقطاع العام',
  'graphic design': 'التصميم الجرافيكي',
  'healthcare and medicine': 'الرعاية الصحية والطب',
  hospitality: 'الضيافة',
  'human resources': 'الموارد البشرية',
  'humanitarian aid': 'العمل الإنساني',
  'information security': 'أمن المعلومات',
  legal: 'الشؤون القانونية',
  logistics: 'الخدمات اللوجستية',
  manufacturing: 'التصنيع',
  'market research': 'أبحاث السوق',
  'natural resources': 'الموارد الطبيعية',
  'operations management': 'إدارة العمليات',
  'product management': 'إدارة المنتجات',
  'program and project management': 'إدارة البرامج والمشاريع',
  'project management': 'إدارة المشاريع',
  'public relations': 'العلاقات العامة',
  'quality control': 'ضبط الجودة',
  'real estate': 'العقارات',
  research: 'البحث',
  sales: 'المبيعات',
  science: 'العلوم',
  'social media management': 'إدارة وسائل التواصل الاجتماعي',
  'software and information technology': 'البرمجيات وتقنية المعلومات',
  'software and it': 'البرمجيات وتقنية المعلومات',
  'software it': 'البرمجيات وتقنية المعلومات',
  'supply chain and distribution': 'سلسلة الإمداد والتوزيع',
  'web development': 'تطوير الويب',
  'writing and publishing': 'الكتابة والنشر',
  'ai ml': 'الذكاء الاصطناعي وتعلّم الآلة',
  'ai ml engineering': 'هندسة الذكاء الاصطناعي وتعلّم الآلة',
  'software engineering': 'هندسة البرمجيات',
  product: 'المنتجات',
};

function localizedPair(value, language, mapping) {
  if (!value) return '';
  const pair = mapping[normalizedKey(value)];
  if (!pair) return humanize(value);
  return pair[language === 'ar' ? 1 : 0];
}

export function localizeWorkMode(value, language = 'en') {
  return localizedPair(value, language, WORK_MODES);
}

export function localizeEmploymentType(value, language = 'en') {
  return localizedPair(value, language, EMPLOYMENT_TYPES);
}

export function localizeJobCategory(value, language = 'en') {
  if (!value) return '';
  if (language !== 'ar') return humanize(value);
  return JOB_CATEGORIES_AR[normalizedKey(value)] || humanize(value);
}
